import { SocialNetwork} from './socialnetwork.model';
import { TvLayout } from './tvlayout.model';

export class TvFormat {

    private active: boolean;
    private centerInternalId: string;
    private checkPrincipalDesk: boolean;
    private deviceImage: string;
    private deviceModel: string;
    private deviceName: string;
    private deviceSerialNumber: string;
    private deviceTypeImage: string;
    private deviceTypeName: string;
    private internalId: string;
    private lastConnection: number;
    private locked: boolean;
    private principalDeskInternalId: number;
    private socialNetworkList: SocialNetwork[];
    private status: string;
    private tvLayout: TvLayout;

    constructor(active?: boolean, centerInternalId?: string, checkPrincipalDesk?: boolean, deviceImage?: string, deviceModel?: string, deviceName?: string, deviceSerialNumber?: string, deviceTypeImage?: string, deviceTypeName?: string, internalId?: string, lastConnection?: number, locked?: boolean, principalDeskInternalId?: number, socialNetworkList?: SocialNetwork[], status?: string, tvLayout?: TvLayout) {
        this.active = active;
        this.centerInternalId = centerInternalId;
        this.checkPrincipalDesk = checkPrincipalDesk;
        this.deviceImage = deviceImage;
        this.deviceModel = deviceModel;
        this.deviceName = deviceName;
        this.deviceSerialNumber = deviceSerialNumber;
        this.deviceTypeImage = deviceTypeImage;
        this.deviceTypeName = deviceTypeName;
        this.internalId = internalId;
        this.lastConnection = lastConnection;
        this.locked = locked;
        this.principalDeskInternalId = principalDeskInternalId;
        this.socialNetworkList = socialNetworkList;
        this.status = status;
        this.tvLayout = tvLayout;
    }

    public get Active() {
        return this.active;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CheckPrincipalDesk() {
        return this.checkPrincipalDesk;
    }
    public get DeviceImage() {
        return this.deviceImage;
    }
    public get DeviceModel() {
        return this.deviceModel;
    }
    public get DeviceName() {
        return this.deviceName;
    }
    public get DeviceSerialNumber() {
        return this.deviceSerialNumber;
    }
    public get DeviceTypeImage() {
        return this.deviceTypeImage;
    }
    public get DeviceTypeName() {
        return this.deviceTypeName;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get LastConnection() {
        return this.lastConnection;
    }
    public get Locked() {
        return this.locked;
    }
    public get PrincipalDeskInternalId() {
        return this.principalDeskInternalId;
    }
    public get SocialNetworkList() {
        return this.socialNetworkList;
    }
    public get Status() {
        return this.status;
    }
    public get TvLayout() {
        return this.tvLayout;
    }
    public set Active(active) {
        this.active = active;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CheckPrincipalDesk(checkPrincipalDesk) {
        this.checkPrincipalDesk = checkPrincipalDesk;
    }
    public set DeviceImage(deviceImage) {
        this.deviceImage = deviceImage;
    }
    public set DeviceModel(deviceModel) {
        this.deviceModel = deviceModel;
    }
    public set DeviceName(deviceName) {
        this.deviceName = deviceName;
    }
    public set DeviceSerialNumber(deviceSerialNumber) {
        this.deviceSerialNumber = deviceSerialNumber;
    }
    public set DeviceTypeImage(deviceTypeImage) {
        this.deviceTypeImage = deviceTypeImage;
    }
    public set DeviceTypeName(deviceTypeName) {
        this.deviceTypeName = deviceTypeName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set LastConnection(lastConnection) {
        this.lastConnection = lastConnection;
    }
    public set Locked(locked) {
        this.locked = locked;
    }
    public set PrincipalDeskInternalId(principalDeskInternalId) {
        this.principalDeskInternalId = principalDeskInternalId;
    }
    public set SocialNetworkList(socialNetworkList) {
        this.socialNetworkList = socialNetworkList;
    }
    public set Status(status) {
        this.status = status;
    }
    public set TvLayout(tvLayout) {
        this.tvLayout = tvLayout;
    }
}
